import Slider from '../components/slider';

export default {
  init() {
    // Init selected news slider
    const selectedNewsSlider = document.querySelector('.o-section--selected-news .o-slider');

    new Slider(selectedNewsSlider, {
      slidesPerView: 1,
      spaceBetween: 0,
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/magazin.js